export const RANKS = [
  { value: "MASTER_CAPTAIN", label: "Master / Captain" },
  { value: "CHIEF_OFFICER_CHIEF_MATE", label: "Chief Officer / Chief Mate" },
  { value: "SECOND_OFFICER", label: "Second Officer" },
  { value: "WATCH_KEEPING_DECK_OFFICER_OINW_OR_THIRD_OFFICER", label: "Watch Keeping Deck Officer OINW or Third officer" },
  { value: "DECK_CADET", label: "Deck Cadet" },
  { value: "MASTER_NCV", label: "Master (NCV)" },
  { value: "CHIEF_OFFICER_NCV", label: "Chief Officer (NCV)" },
  { value: "SECOND_OFFICER_NCV", label: "Second Officer (NCV)" },
  { value: "WATCH_KEEPING_DECK_OFFICER_NCV_OINW", label: "Watch Keeping Deck Officer (NCV) OINW" },
  { value: "OTHER_OFFICER", label: "Other Officer" },
  { value: "DECK_PETTY_OFFICER", label: "Deck Petty Officer" },
  { value: "DECK_WATCHKEEPING_RATING", label: "Deck Watchkeeping Rating" },
  { value: "DECK_SERANG", label: "Deck Serang" },
  { value: "DECK_RATING", label: "Deck Rating" },
  { value: "TRAINEE_DECK_RATING", label: "Trainee Deck Rating" },
  { value: "OTHER_SENIOR_DECK_NAUTICAL_OFFICERS", label: "Other Senior Deck/Nautical Officers" },
  { value: "OTHER_DECK_NAUTICAL_OFFICERS", label: "Other Deck/Nautical Officers" },
  { value: "CHIEF_ENGINEER", label: "Chief Engineer" },
  { value: "2ND_ENGINEER", label: "2nd Engineer" },
  { value: "3RD_ENGINEER", label: "3rd Engineer" },
  { value: "WATCH_KEEPING_ENGINEER_OFFICER_OICEW", label: "Watch Keeping Engineer Officer OICEW" },
  { value: "TRAINEE_MARINE_ENGINEER", label: "Trainee Marine Engineer" },
  { value: "ENGINEER_CADET", label: "Engineer Cadet" },
  { value: "CHIEF_ENGINEER_NCV", label: "Chief Engineer (NCV)" },
  { value: "2ND_ENGINEER_NCV", label: "2nd Engineer (NCV)" },
  { value: "WATCHKEEPING_ENGINEER_OFFICER_NCV_OICEW", label: "Watchkeeping Engineer Officer (NCV) OICEW" },
  { value: "ELECTRICAL_ELECTRONICS_OFFICER", label: "Electrical/Electronics Officer" },
  { value: "ASSISTANT_ELECTRICAL_ELECTRONICS_OFFICER", label: "Assistant Electrical/Electronics Officer" },
  { value: "ENGINE_PETTY_OFFICER", label: "Engine Petty Officer" },
  { value: "WATCH_KEEPING_MOTOR_MAN", label: "Watch keeping Motor Man" },
  { value: "ENGINE_SERANG", label: "Engine Serang" },
  { value: "ENGINE_RATING", label: "Engine Rating" },
  { value: "TRAINEE_ENGINE_RATING", label: "Trainee Engine Rating" },
  { value: "OTHER_SENIOR_ENGINEERING_OFFICERS", label: "Other Senior Engineering Officers" },
  { value: "OTHER_ENGINEERING_OFFICERS", label: "Other Engineering Officers" },
  { value: "TRAINEE_POLYVALENT_OFFICER", label: "Trainee Polyvalent Officer" },
  { value: "GP_RATING", label: "GP Rating" },
  { value: "GP_RATING_TRAINEE", label: "GP Rating Trainee" },
  { value: "RADIO_OFFICER", label: "Radio Officer" },
  { value: "JUNIOR_RADIO_OFFICER", label: "Junior Radio Officer" },
  { value: "RADIO_OFFICER_TRAINEE", label: "Radio Officer Trainee" },
  { value: "MEDICAL_OFFICER_DOCTOR", label: "Medical Officer (Doctor)" },
  { value: "DOCTOR_ASSISTANT", label: "Doctor-Assistant" },
  { value: "CATERING_OFFICER_CHIEF_STEWARD", label: "Catering Officer/Chief Steward" },
  { value: "COOK", label: "Cook" },
  { value: "SALOON_RATING", label: "Saloon Rating" },
  { value: "TRAINEE_SALOON_RATING", label: "Trainee Saloon Rating" },
  { value: "COOK_TRAINEE", label: "Cook Trainee" },
  { value: "CREW_OTHERS", label: "Crew (Others)" },
  { value: "ELECTRO_TECHNICAL_OFFICER", label: "Electro Technical Officer" },
  { value: "NCV_DECK", label: "NCV (Deck)" },
  { value: "HOSPITALITY_STAFF", label: "Hospitality Staff" },
  { value: "HOSPITALITY_STAFF_NEW_ENTRANT", label: "Hospitality Staff (New Entrant)" },
  { value: "ORDINARY_SEAMAN", label: "Ordinary Seaman" },
  { value: "A_B", label: "A B" },
  { value: "OILER", label: "Oiler" },
  { value: "SEAMAN", label: "Seaman" },
  { value: "DECK_STEWARD", label: "Deck Steward" },
  { value: "H_K_CLEANER", label: "H K Cleaner" },
  { value: "MOTORMAN", label: "Motorman" },
  { value: "GEN_ENGINEER", label: "Gen Engineer" },
  { value: "PUMPMAN", label: "Pumpman" },
  { value: "WIPER", label: "Wiper" },
  { value: "CAMP_BOSS", label: "Camp Boss" },
  { value: "ASSISTANT_CAMP_BOSS", label: "Assistant Camp Boss" },
  { value: "REEFER", label: "Reefer" },
  { value: "ASSISTANT_REEFER", label: "Assistant Reefer" },
  { value: "BOSUN", label: "Bosun" },
  { value: "CARPENTER", label: "Carpenter" },
  { value: "CRANE_OPERATOR", label: "Crane Operator" },
  { value: "MECHANIC", label: "Mechanic" },
  { value: "CADET_RATING_APPEARED_FOR_COC_EXAM", label: "Cadet / Rating appeared for CoC Exam" },
  { value: "CRUISE_VESSEL_EMPLOYEES", label: "Cruise Vessel Employees" },
  { value: "JUNIOR_OFFICER", label: "Junior Officer" },
  { value: "MARINE_ENGINEER", label: "Marine Engineer" },
  { value: "DREDGE_MASTER_GRADE_I", label: "Dredge Master Grade I" },
  { value: "DREDGE_MASTER_GRADE_II", label: "Dredge Master Grade II" },
  { value: "DREDGE_MATE_GRADE_I", label: "Dredge Mate Grade I" },
  { value: "DREDGE_MATE_GRADE_II", label: "Dredge Mate Grade II" },
  { value: "DREDGE_ENGINEER_GRADE_I", label: "Dredge Engineer Grade I" },
  { value: "DREDGE_ENGINEER_GRADE_II", label: "Dredge Engineer Grade II" },
  { value: "CHIEF_PIPE_OPERATOR", label: "Chief Pipe Operator" },
  { value: "PIPE_OPERATOR", label: "Pipe Operator" },
  { value: "SKIPPER", label: "Skipper" },
  { value: "RATING_TRAINEE_CADET_PUMPMAN_COOK", label: "Rating/Trainee/Cadet/Pumpman/Cook" },
  { value: "ELECTRO_TECHNICAL_RATING", label: "Electro Technical Rating" },
  { value: "ELECTRO_TECHNICAL_CADET", label: "Electro Technical Cadet" },
  { value: "HANDLER", label: "Handler" },
  { value: "IV_MASTER", label: "IV Master" },
  { value: "GENERAL_STEWARD", label: "General Steward" },
] as const;

export type RankOption = (typeof RANKS)[number];

/** Display labels stored on users.rankDesignation */
export const RANK_LABELS: string[] = RANKS.map((rank) => rank.label);

export function isListedRank(value?: string | null): boolean {
  if (!value) return false;
  return RANK_LABELS.some((label) => label.toLowerCase() === value.trim().toLowerCase());
}

export const GENDERS = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
  { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
];

export const USER_ROLES = [
  { value: "SEAFARER", label: "SEAFARER" },
  { value: "ADMIN", label: "ADMIN" },
  { value: "SUPER_ADMIN", label: "SUPER_ADMIN" },
];

export const USER_STATUS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
];
